<template>
    <div class="page-container">
        <div class="left-box">
            <LeftPage :active="4"/>
        </div>
        <div class="right-box flex flex-direction">
            <div class="title flex justify-between">
                <div class="flex align-center">
                    <div class="icon-box">
                        <i class="iconfont icon-xiazai1"></i>
                    </div>
                    <b>下载中心管理</b>
                </div>
                <div class="page-cancel" @click="$router.go(-1)">
                    <i class="icon iconfont icon-jiantouzuo1"></i>返回
                </div>
            </div>
            <el-form ref="ruleForm" v-loading="loading" :model="ruleForm" :rules="rules" class="ruleForm publish-form margin-top-sm" label-width="auto">
                <el-row :gutter="20">
                    <el-col :span="11">
                        <el-form-item ref="title" class="input-container" label="文件名称" prop="title">
                            <el-input v-model="ruleForm.title" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="11">
                        <el-form-item ref="desc" class="input-container" label="文件描述" prop="desc">
                            <el-input v-model="ruleForm.desc" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-if="false">
                    <el-col :span="11">
                        <el-form-item ref="reid" class="input-container" label="文件分类" prop="reid">
                            <el-select style="width: 100%" v-model="ruleForm.reid" placeholder="请选择" class="inp">
                                <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="11">
                        <el-form-item ref="files" class="input-container" label="文件" prop="files">
                            <div class="flex flex-direction">
<!--                                <div v-for="(item,index) in ruleForm.files" :key="index" class="flex align-center margin-bottom-xs">-->
                                    <el-link class="self-start margin-bottom-xs" type="primary" :href=ruleForm.files target="_blank" v-if="ruleForm.files">已上传文件
                                    </el-link>
<!--                                    <i class="el-icon-delete margin-left-sm" @click="delItem(index)"></i>-->
<!--                                </div>-->
                                <upload-file class="flex justify-start" name="files" @uploadFile="uploadFile">
                                    <el-button slot="upload" type="primary">上传文件</el-button>
                                </upload-file>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>


                <el-row :gutter="20">
                    <el-col :span="11">
                        <el-form-item ref="is_top" class="input-container" label="参数" prop="is_top">
                            <el-switch v-model="ruleForm.is_top" active-text="置顶" :active-value="1" :inactive-value="0"></el-switch>
                            <el-switch class="margin-left-sm" v-model="ruleForm.is_tui" active-text="推荐" :active-value="1" :inactive-value="0"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-button :loading="submit_loading" class="btn max round margin-tb-sm self-center"
                       type="primary" @click="submitForm('ruleForm')">
                添加
            </el-button>
        </div>
    </div>
</template>

<script>

import LeftPage from "@/views/admin/pages/info/common/leftPage";
import {scrollIntoView} from "@/utils/utils";
import UploadFile from "@/components/UploadFile";
import {getArticleDetail, getCatArticleList, saveArticle} from "@/api/admin";

export default {
    name: "add",
    components: {UploadFile, LeftPage},
    data() {
        return {
            id: '',
            categoryList:[],
            ruleForm: {
                title: '',//标题
                desc: '',//描述
                cid: 4,//模块1政策法规2通知公告3宣传信息4下载中心
                is_top: '',//0未置顶1置顶
                is_tui: '',//0未推荐1推荐
                status: 1,//状态0隐藏1展示
                thumb: '',//缩略图
                content: '',//内容
                files: '',//附件
                reid: '',//分类（下载）
                author: '',//作者
                resource: '',//来源
                publish_time: '',//更新时间
            },
            rules: {
                title: [
                    {required: true, message: '请输入标题', trigger: 'blur'},
                ],
                desc: [
                    {required: true, message: '请输入描述', trigger: 'blur'},
                ],
                content: [
                    {required: true, message: '请输入内容', trigger: 'blur'},
                ],
                author: [
                    {required: true, message: '请输入作者', trigger: 'blur'},
                ],
                resource: [
                    {required: true, message: '请输入来源', trigger: 'blur'},
                ],
                publish_time: [
                    {required: true, message: '请选择更新时间', trigger: 'change'},
                ],
                reid: [
                    {required: true, message: '请选择分类', trigger: 'change'},
                ],
                files: [
                    {required: true, message: '请上传附件', trigger: 'change'},
                ]
            },
            loading: false,
            submit_loading: false,
        }
    },
    computed: {},
    created() {
        this.$emit("setActive", {
            headActive: 5
        })
        this.id = this.$route.query.id || ''
        if (this.id) this.init()
        this.getCatArticleList()
    },
    methods: {
        async getCatArticleList(){
            let _data = await getCatArticleList(1,10000)
            this.categoryList = _data.data.data
        },
        async init() {
            this.loading = true
            let _data = await getArticleDetail(this.id)
            this.ruleForm.title = _data.data.title
            this.ruleForm.desc = _data.data.desc
            this.ruleForm.is_top = _data.data.is_top
            this.ruleForm.is_tui = _data.data.is_tui
            this.ruleForm.status = _data.data.status
            this.ruleForm.thumb = _data.data.thumb
            this.ruleForm.content = _data.data.content
            this.ruleForm.files = _data.data.files
            this.ruleForm.reid = _data.data.reid
            this.ruleForm.author = _data.data.author
            this.ruleForm.resource = _data.data.resource
            this.ruleForm.publish_time = _data.data.publish_time
            this.loading = false
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid, validates) => {
                if (valid) {
                    this.submitInfo();
                } else {
                    scrollIntoView(this, validates)
                }
            });
        },
        async submitInfo() {
            this.submit_loading = true
            let _data = await saveArticle(
                this.id,
                this.ruleForm.title,
                this.ruleForm.desc,
                this.ruleForm.cid,
                this.ruleForm.is_top,
                this.ruleForm.is_tui,
                this.ruleForm.status,
                this.ruleForm.thumb,
                this.ruleForm.content,
                this.ruleForm.files,
                this.ruleForm.reid,
                this.ruleForm.author,
                this.ruleForm.resource,
                this.ruleForm.publish_time
            )
            this.submit_loading = false
            if (_data.status == 200){
                this.$message.success(_data.msg)
                if(!this.id){
                    this.$router.go(-1)
                }
            }else {
                this.$message.error(_data.msg)
            }
        },
        uploadFile(data) {
            this.ruleForm[data.name] = data.file.url
        },
        delItem(index) {
            this.ruleForm.files.splice(index, 1)
        }
    }
}
</script>

<style lang="scss" scoped>

.page-container {
    width: 100%;
    min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;
    padding: 20px;
    display: flex;
    justify-content: flex-start;

    .title {
        display: flex;
        align-items: center;
        padding-bottom: 25px;
        border-bottom: 1px solid #e3e7f0;

        b {
            font-size: 22px;
            color: #16181d;
            font-weight: bold;
            margin-left: 10px;
        }

        .icon-box {
            width: 30px;
            height: 30px;
            background-image: linear-gradient(-30deg,
                #3579fb 0%,
                #44a3ff 100%);
            box-shadow: 0px 10px 10px 0px rgba(50, 150, 255, 0.3);
            border-radius: 10px;
            text-align: center;
            line-height: 30px;

            i {
                font-size: 20px;
                color: #ffffff;
            }
        }
    }

    .right-box {
        flex: 1;
        margin-left: 25px;
        width: 100%;
        height: 100%;
        min-height: calc(100vh - (173px + 159px));
        background-image: linear-gradient(0deg,
            #ffffff 84%,
            #edf6ff 100%);
        padding: 30px 20px 0;
        border-radius: 10px;
    }

    .image {
        width: 135px;
        height: 101px;
        border-radius: 10px;
        border: 1px solid var(--grayLine);
    }
}
</style>
